@if (tour.constructionSite.projectNumber) {
  <ngx-barcode6
    bc-value="{{tour.customer.customerNr + '-' + tour.constructionSite.projectNumber}}"
    bc-format="CODE128"
    bc-width="1"
    bc-height="35"
    bc-display-value="true"
    bc-font-size="13"
  ></ngx-barcode6>
}
